/*
  This file is duplicated in:
    avalanche/assets/js/admin/cms/template/components/FreeEventCountdown.js
    typhoon/assets/js/view_invitation/special-features/components/FreeEventCountdown.js

  please keep in sync as needed
*/

import React from 'react';

function padNumber(num, size) {
  let s = `${num}`;
  while (s.length < size) s = `0${s}`;
  return s;
}

export class FreeEventCountdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getDateDelta(new Date(), props);
    if (!this.props.countdown) console.log('Missing countdown');
    else if (this.props.countdown.date_format !== 'separate')
      console.log('Unknown date_format: ', this.props.countdown.date_format);
  }

  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (this.props.startTime !== nextProps.startTime)
      this.setState(this.getDateDelta(new Date(), nextProps));
  }

  tick() {
    this.setState(this.getDateDelta(new Date(), this.props));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      JSON.stringify(nextProps) === JSON.stringify(this.props) &&
      JSON.stringify(nextState) === JSON.stringify(this.state)
    );
  }

  getDateDelta(date, props) {
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    let expired = true;
    const start_ms = new XDate(props.startTime).getTime();
    const milliseconds = start_ms - date.getTime();
    if (milliseconds > 0) {
      days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
      hours = Math.floor(milliseconds / (1000 * 60 * 60)) % 24;
      minutes = Math.floor(milliseconds / (1000 * 60)) % 60;
      seconds = Math.floor(milliseconds / 1000) % 60;
      expired = false;
    }
    return {
      days,
      hours,
      minutes,
      seconds,
      expired,
    };
  }

  render() {
    if (this.props.mobile) {
      let fontFamily = this.props.countdown.mobile_font_family;
      if (fontFamily === 'Heroid') fontFamily = 'HeroidRegular';
      if (this.props.countdown.date_format === 'separate')
        return (
          <div
            id="countdown_container"
            className={`mobile-countdown ${
              this.state.expired ? 'timer-expired' : ''
            } mobile-position-${this.props.countdown.mobile_position}`}
            style={{
              fontFamily,
              fontSize: this.props.countdown.mobile_font_size * this.props.scale,
              color: this.props.countdown.mobile_font_color,
            }}
          >
            <link
              rel="stylesheet"
              type="text/css"
              href={`//fonts.evitecdn.com/assets/fonts/${fontFamily}.css`}
            />
            <div id="countdown_days">{padNumber(this.state.days, 2)}</div>
            <div id="countdown_hours">{padNumber(this.state.hours, 2)}</div>
            <div id="countdown_minutes">{padNumber(this.state.minutes, 2)}</div>
            <div id="countdown_seconds">{padNumber(this.state.seconds, 2)}</div>
          </div>
        );
      return;
    }
    if (this.props.countdown.date_format === 'separate')
      return (
        <div id="countdown_container" className={this.state.expired ? 'timer-expired' : ''}>
          <div id="countdown_days">{padNumber(this.state.days, 2)}</div>
          <div id="countdown_hours">{padNumber(this.state.hours, 2)}</div>
          <div id="countdown_minutes">{padNumber(this.state.minutes, 2)}</div>
          <div id="countdown_seconds">{padNumber(this.state.seconds, 2)}</div>
        </div>
      );
  }
}
